/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';

export const EmptyColumnPlaceholder: React.FC = () => <span />;
